<template>
  <fragment>
  <tr style="border-top: 1px solid #eee">
      <td class="align-middle">{{shipIndex+1}}</td>
      <td class="align-middle squeeze">
          <div>
          </div>
      </td>

      <td>
          <input :disabled="readOnly" class='sparse-text' type='text' v-model="row.description" :id="'tertiaryDesc'+shipIndex"
            autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
            placeholder="description..."
            v-validate="'required'"
            v-on:keyup="productLiveSearch"
          />
          <div :id="'tertiaryDesc'+shipIndex+'auto'" class="customLiveSearch" style="max-width: 240px;" v-show="productrows && productrows.length">
            <template v-for="(product, pIdx) in productrows">
              <div :key="pIdx" class="customLiveSearchElement" v-on:click="productSelected(product)">{{ product.description }}</div>
            </template>
          </div>
      </td>

      <td>
        <input class='sparse-text' type='text' v-model="row.lot" :id="'tertiaryLot'+shipIndex"
          autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
          placeholder="lot number..."
          v-on:keyup="lotLiveSearch($event, row)"
          v-on:click="showLots($event, row)"
          :disabled="readOnly"
        />
        <div :id="'tertiaryLot'+shipIndex+'auto'" class="customLiveSearch" style="max-width: 240px;" v-show="lotRows.length > 0">
          <template v-for="(lot, lIdx) in lotRows">
            <div :key="lIdx" class="customLiveSearchElement" v-on:click="lotSelected(row, lot)">{{ lot.name + ' (' + lot.available + ')' }}</div>
          </template>
        </div>
      </td>

      <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="row.quantity" /></td>
      <td class="text-center align-middle" :title="row.type + ': ' + row.apiIntegration + ' -- ' + row.internalId">                        
        <select :disabled="readOnly" class="form-control form-control-sm sparse-text" v-model="row.stackable">
          <option :value="true">Yes</option>
          <option :value="false">No</option>
        </select>
      </td>
      <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="row.length" /></td>
      <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="row.width" /></td>
      <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="row.height" /></td>
      <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="row.weight" /> </td>
      <td class="text-center align-middle">                        
        <select class="form-control form-control-sm sparse-text expander" v-model="row.hazardous" :disabled="readOnly">
          <option :value="true">Yes</option>
          <option :value="false">No</option>
        </select>
      </td>
      <td>
          <button type="button"
          :class="'btn btn-sm btn-block text-left text-nowrap ' + (this.expanded ? row.components.find(c => c.expanded) ? 'btn-primary-inactive' : 'btn-primary-inactive' : 'btn-secondary')"
          :disabled="row.type == 'None'"
          v-on:click="onUnitsExpand">
              <span class="d-block ">
                  {{numSecondaryUnits || '---'}}
                  <span class="float-right" v-if="row.type != 'None'"><i :class="expanded ? 'fa fa-chevron-up spinEffect' : 'fa fa-chevron-down spinEffectReverse'"></i></span>
              </span>
          </button>
      </td>
      <td class="align-middle text-nowrap">
          <a v-if="!readOnly" class="text-body" v-on:click="cloneRow"><i class="fa fa-fw fa-copy"></i></a>
          <a v-if="!readOnly" class="text-danger" v-on:click="removeRow"><i class="fa fa-fw fa-times" ></i></a>
      </td>
  </tr>

  <template v-for="(unit,unitIndex) in this.row.components">
      <SecondaryRow :key="'secondary_'+unitIndex" :customerCompanyEntity="customerCompanyEntity" :unit="unit" :unitIndex="unitIndex" :show="expanded" :rowIndex="shipIndex"
        v-on:removeUnit="removeUnit(unitIndex)"
        v-on:cloneUnit="duplicateUnit(unit, unitIndex)"
        :readOnly="readOnly"
      />
  </template>


  <tr class="bg-gray" :key="'secondary_unit_add'+ shipIndex" v-show="expanded">
      <td colspan="2" class="bg-white border-0"></td>    
      <td colspan="11" class="text-right">
        <button v-if="!readOnly" class="btn btn-clear" v-on:click="addSecondaryUnit"><i class="fa fa-plus-circle"></i> ADD ROW</button>
      </td>
  </tr>

  </fragment>
</template>

<script>

import SecondaryRow from './SecondaryRow.vue';
import { filterInventoryList, getLotNumbers } from '../../utils/autocompleteProducts'
import { DIVA_COMPANY_ID } from "../../constants/entities";

var productrows = [];
var lotRows = [];

const defaultSecondaryUnit = () => ({
  internalId: "",
  description: "",
  quantity: 1,
  length: 1,
  width: 1,
  height: 1,
  dimensionunit: 4,
  weight: 1,
  weightunit: 2,
  lot: '',
  unitsPerCase: 1,
  components: [],
  hazardous: false,
  stackable: true,
  includeInTransferOrder: false,
  expanded: false,
});

const formatTextFields = function() {
  document.querySelectorAll('.expander').forEach(function( input ) {
    const extraSpace = input.type == 'text' ? 2 : 5;
    input.style.width=(input.value.length+extraSpace)+'ch';
    input.oninput= function() {
      input.style.width=(input.value.length+extraSpace)+'ch';
    }
  });
};

export default {
  name: 'ShippingLvls',

  props: {
    customerCompanyEntity: {
      type: String,
      required: false
    },
    row: {type: Object },
    shipIndex: {type: Number },
    readOnly: {type: Boolean },
    showCarbon: {type: Boolean },
    readOnly: {type: Boolean },
  },

  components: {
    SecondaryRow,
  },

  data: function () {
    return {
      expanded: this.row.expanded,
      productrows,
      lotRows,
    }
  },

  mounted () {
    console.log("--------------------------------------- mounted");
    // this.$nextTick(formatTextFields);
    console.log("--------------------------------------- ticked");
  },
  computed: {

    numSecondaryUnits: function() {
      let total = 0;
      for (var i = 0; i < this.row.components.length; i++) {
        total += this.row.components[i].quantity * this.row.quantity;
      }
      return total || this.row.quantity*this.row.unitsPerCase;
    }

  },
  methods: {

    productLiveSearch: async function (event) {
      console.log("product search " + event.target.id + " " + event.target.value);
      const text = event.target.value;
      if (text.length < 1) {
        this.dissmissAutoCompletes();
      } else {
        this.productrows = await filterInventoryList(text);
        if (this.productrows.length) {
          this.showAutoComplete(event.target.id+'auto');
        }
      }
    },
    productSelected: async function (product) {
      console.log('productSelected ' + product.apiIntegration + " " + product.type + " " + product.unitsPerCase);
      const [lengthUnits, weightUnits] = this.$parent.shippingDimensionUnits.split('/');
      this.dissmissAutoCompletes();
      if(product) {
          this.row.internalId = product.internalId;
          this.row.description = product.description;
          this.row.dimensionunit = lengthUnits == "in" ? 4 : 1;
          this.row.height = product.dimensions.height;
          this.row.length = product.dimensions.length;
          this.row.quantity = this.row.quantity || 1;
          this.row.weight = product.dimensions.weight;
          this.row.weightunit = weightUnits == "kgs" ? 1 : 2;
          this.row.width = product.dimensions.width;
          this.row.lot = "";
          this.row.type = product.type;
          this.row.unitsPerCase = product.unitsPerCase;
          this.row.apiIntegration = product.apiIntegration;
          this.row.hazardous = false;
          this.row.stackable = product.type == "Skid" ? false : true;

          this.row.expanded = false;
          //this.$nextTick(formatTextFields);
      }
    },

    showLots: async function(event, u) {
      console.log("showLots");
      event.stopPropagation();
      event.preventDefault();
      this.lotRows = await getLotNumbers(u.internalId, u.quantity);
      if (this.lotRows.length > 0) {
        await this.$nextTick(this.showAutoComplete(event.target.id+'auto')); 
        this.showAutoComplete(event.target.id+'auto');
      }
    },

    lotLiveSearch: async function (event, u) {
      console.log("lotLiveSearch " + event.target.id + " " + event.target.value + " " + u.internalId);
      const text = event.target.value;

      // only filter when text is valid and for DIVA customers
      if (text.length > 0 && this.customerCompanyEntity == DIVA_COMPANY_ID) {

        // filter from full list
        const fullLotList = await getLotNumbers(u.internalId, u.quantity);
        if (fullLotList) {
          this.lotRows = fullLotList.filter(lot => lot.name.includes(text));
        }
        this.showAutoComplete(event.target.id+'auto');
      }
    },
    lotSelected: function (u, lot) {
      console.log('lotSelected ' + JSON.stringify(lot));
      if (lot) {
        u.lot = lot.name;
        u.available = lot.available;
        this.$forceUpdate();
      }
       this.dissmissAutoCompletes();
    },

    dissmissAutoCompletes: function() {
      $(".customLiveSearch").hide();
    },

    showAutoComplete: function(id) {
      document.getElementById(id).style.display = 'block';
    },

    addSecondaryUnit() {
      if(!Array.isArray(this.row.components)) this.row.components = [];
      this.row.components.push(defaultSecondaryUnit());
      console.log('addSecondaryUnit');
      console.log(this.row.components);
      //this.$nextTick(formatTextFields);
    },
    cloneRow() {
      this.$emit('cloneRow');
      // this.$nextTick(formatTextFields);
    },
    removeRow() {
      this.expanded = false;
      this.$emit('removeRow');
    },

    onUnitsExpand() {
      console.log("expand! " + this.expanded);
      this.expanded = !this.expanded;
      this.$forceUpdate();
    },

    duplicateUnit: function (unit, index) {
      const unitCopy = {
        ...unit,
        components: unit.components.map(primaryLvl => ({...primaryLvl})),
      };
      this.row.components.splice(index + 1, 0, unitCopy)
    },

    removeUnit: function (index) {
      console.log('remove unit ' + index);
      if (this.row.components.length > 0) {
        this.row.components.splice(index,1);
      }
    },
  }
}
</script>

<style>

  .table td, .table th {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }

  .bg-gray {background-color: #F8F8F8;}
  .squeeze {width: 1%;}
  th {font-size: 0.7rem; text-transform: uppercase;}
  .header-dark {color: white; background-color: #4C7A34;}
  .header-active {  background-color: #94AF85; color: white; }
  .text-sm {font-size: 0.8rem;}
  .inset-primary-left-header {
      background: linear-gradient(90deg, rgba(248,248,248,1) 0px, rgba(248,248,248,1) 15px, #4C7A34 15px, #4C7A34 100%);
      padding-left: 25px !important;   
  }
  .inset-primary-left-body {
      background: linear-gradient(90deg, rgba(248,248,248,1) 0px, rgba(248,248,248,1) 15px, rgba(255,255,255,1) 15px, rgba(255,255,255,1) 100%);
      padding-left: 25px !important;  
  }

  table td, .table th {
    border-top: none !important;
  }

  .border-top {
    border-top: 1px solid #e9ecef;
  }

  .btn-combo {
    font-size: 0.75rem;
    border-radius: 3px;
    padding: 5px 10px;
    border-width: 2px;
    background-color: transparent;
    font-weight: 400;
    padding: 8px 16px;
    cursor: pointer;
    margin-bottom: 5px;
    font-size: 0.875rem;
    line-height: 1.42857143;
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    transition: all .15s ease-in-out;
  }

  .btn-active {
    background-color: #4C7A34 !important;
    border: 1px solid #4C7A34 !important;
    color:#fff;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
  }

  .btn-active:hover, .btn-active:focus, .btn-active:active, .open > .btn-active.dropdown-toggle {
    background-color: #4C8A34 !important;
    border: 1px solid #4C7A34 !important;
    color:#fff;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
  }

  .btn-primary-inactive {
    background-color: #94AF85 !important; 
    border: 1px solid #4C7A34 !important;
    color:#FFF;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
    font-weight: 500;
    height: calc(1.8125rem + 2px);
    margin-top: 4px;
  }

  .btn-primary-inactive:hover, .btn-primary-inactive:focus, .btn-primary-inactive:active, .btn-primary-inactive.active, .open > .btn-primary-inactive.dropdown-toggle {
    background-color: #4C7A34 !important;
    border-color: #4C7A34 !important;
    color:#FFF !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
  }

  .btn-primary {
    background-color: #4C7A34 !important; 
    border: 1px solid #4C7A34 !important;
    color:#FFF;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
    font-weight: 500;
    height: calc(1.8125rem + 2px);
    margin-top: 4px;
  }

  .btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open > .btn-primary.dropdown-toggle {
    background-color: #4C7A34 !important;
    border-color: #4C7A34 !important;
    color:#FFF !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
  }

  .btn-secondary {
    background-color: #efe !important;
    border: 1px solid #ddd !important;
    color: #000 !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
    font-weight: 500;
    height: calc(1.8125rem + 2px);
    margin-top: 4px;
  }

  .btn-secondary:hover, .btn-secondary:focus, .btn-secondary:active, .btn-secondary.active, .open > .btn-secondary.dropdown-toggle {
    background-color: #e8f8e8 !important;
    border: 1px solid #ddd !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
  }

  .btn-secondary:disabled {
    background-color: #fff !important;
    border: 1px solid #ddd !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-image: none !important;
  }

  .btn-clear {
    background-color: transparent;
    border: 1px solid transparent;
    color: #4F80EF;
  }

  .sparse-text {
    width: 100% !important;
    min-width: 80px;
    text-align: center;
    border: 1px solid #dddddd;
    border-radius: 4px;
    padding: 4px 4px 4px 4px !important;

  }

  .sparse-text:hover {
    border: 1px solid #72BB53;
  }
  .sparse-text:focus {
    border: 1px solid #72BB53;
  }

  .spinEffect {
    animation: spin 0.5s ease;
  }
  .spinEffectReverse {
    animation: spinRev 0.5s ease;
  }
  @keyframes spin {
    0% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  @keyframes spinRev {
    0% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

</style>


// WEBPACK FOOTER //
// TertiaryRow.vue?e6769e14